export default "__VITE_PUBLIC_ASSET__2bd84458__"